import { errHandler } from "../utils/common";
import api from "../utils/api";

export default class BKK {
  getAll = (
    opt = {
      searchBy: "",
      searchValue: "",
      page: 1,
      limit: 999,
      excludePkm: false,
      province_id: "",
      district_id: "",
    }
  ) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/bkk`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  getIndukByWilker = (idWilker) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/induk-by-wilker`, { params: { id: idWilker } })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
